module.exports = __webpack_public_path__ + "dash_20_app_assets/img/Testimonial.50e3293a.png";